import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Prevents automatic data refetching when browser window regains focus
      // Avoids unnecessary API calls when user switches between tabs
      refetchOnWindowFocus: false,

      // Enables data refresh when component is mounted to the DOM
      // Ensures fresh data when returning to a page or navigating back to a route
      refetchOnMount: true,

      // Number of retry attempts for failed queries before showing an error
      retry: 3,

      // Custom delay logic between retry attempts
      // Implements progressive backoff strategy to prevent server overload
      retryDelay: (failureCount, error) => {
        if (error) {
          if (error.status === 500) {
            const times = [1000, 5000, 9_000];
            return times[failureCount] ?? 10_000;
          }
        }

        return 0; // For other errors - retry immediately
      },

      // Duration (in ms) that data remains "fresh" before considered stale (24 hours)
      // React Query won't automatically refetch in the background during this period
      staleTime: 24 * 60 * 60 * 1000, // 24 hours

      // Duration (in ms) to keep unused data in cache before garbage collection (24 hours)
      // Data is removed from cache after this period if no active components are using it
      gcTime: 24 * 60 * 60 * 1000,

      // Legacy option maintained for compatibility with older React Query versions
      cacheTime: 24 * 60 * 60 * 1000,
    },
  },
});
